<template>
  <b-sidebar
    id="sidebar"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    no-close-on-backdrop
    right
    @shown="loadData"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0 text-capitalize">
          {{ isAdd ? $t("actions.add") : $t("actions.save") }}
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
        <!--
          <validation-provider
            #default="validationContext"
            :name="$t('pisos.name')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('pisos.name')"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="itemData.name"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          -->

          <validation-provider
            :name="$t('pisos.unit_id')"
            rules="required"
            v-slot="{ errors, validate }"
          >
            <b-form-group
              class="text-capitalize"
              :label="$tc('pisos.unit_id', 2)"
              label-for="id_unit"
            >
              <select-paginate
                v-model="unit"
                :items="unitOptions"
                :class="{ 'is-invalid': errors.length }"
              />

              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            :name="$t('pisos.floor_number')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('pisos.floor_number')"
              label-for="floor_number"
            >
              <b-form-input
                id="floor_number"
                v-model="itemData.floor_number"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            :name="$t('pisos.headcount_table')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('pisos.headcount_table')"
              label-for="headcount"
            >
              <b-form-input
                id="headcount"
                v-model="itemData.headcount"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="{ errors }"
            :name="$t('pisos.is_occupied')"
            rules="required"
          >
            <b-form-group class="text-capitalize" :label="$t('pisos.is_occupied')">
              <b-form-radio-group
                v-model="itemData.is_occupied"
                :options="[
                  { text: 'Sí', value: true },
                  { text: 'No', value: false },
                ]"
                name="is_occupied"
              />

              <b-form-invalid-feedback :state="errors.length === 0">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="{ errors }"
            :name="$t('pisos.active')"
          >
              <b-form-checkbox
                v-model="itemData.active"
                name="activo"
                switch
              >
                {{ itemData.active ? $t('pisos.active') : $t('pisos.inactive') }}
              </b-form-checkbox>

              <b-form-invalid-feedback :state="errors.length === 0">
                {{ errors[0] }}
              </b-form-invalid-feedback>
          </validation-provider>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 text-capitalize"
              type="submit"
            >
              {{ isAdd ? $t("actions.add") : $t("actions.save") }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="text-capitalize"
            >
              {{ $t("actions.cancel") }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import { required, alphaNum, email, positive } from "@validations";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import SelectPaginate from "../components/SelectPaginate.vue";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    SelectPaginate,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isSidebarActive",
    event: "update:is-sidebar-active",
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    itemEdit: {
      type: Object,
      required: false,
    },
    unitOptions: {
      type: Array,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
    };
  },
  setup(props, { emit }) {
    const blankData = {
      name: null,
      floor_number: null,
      headcount: null,
      is_occupied: null,
      id_unit: null,
      active: true,
    };

    const toast = useToast();

    const unit = ref(null);

    const itemData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankData));
    };

    const onSubmit = () => {
      let dispatch;
      itemData.value.id_unit = unit.value.value;

      if (props.isAdd) {
        dispatch = store.dispatch("pisos/add", itemData.value);
      } else {
        const req = {
          id: itemData.value.id,
          params: {
            name: itemData.value.name,
            id_unit: itemData.value.id_unit,
            headcount: itemData.value.headcount,
            is_occupied: itemData.value.is_occupied,
            floor_number: itemData.value.floor_number,
            active: itemData.value.active,
          },
        };
        console.log("edit");
        dispatch = store.dispatch("pisos/edit", req);
      }

      dispatch
        .then((response) => {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
            emit("refetch-data");
            emit("update:is-sidebar-active", false);
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetData);

    const loadData = () => {
      if (!props.isAdd) {
        itemData.value = {
          ...props.itemEdit
        };

        unit.value = {
          value: itemData.value.unit?.id,
          label: itemData.value.unit?.description,
        };

        itemData.value.active = Boolean(itemData.value.active ?? 0);
        /*itemData.value.active = Boolean(itemData.value.unit?.active ?? 0);
        console.log({
          value: itemData.value.unit?.id,
          label: itemData.value.unit?.description,
        })*/
      } else {
        unit.value = null;
      }
    };

    return {
      unit,
      itemData,
      onSubmit,
      refFormObserver,
      getValidationState,
      loadData,
      resetForm,
    };
  },
};
</script>

